<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove {{kltg.fctitaal_oms}} {{kltg.kltg_bedrag}} from booking {{kltg.huov_code}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmKltg">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      kltg_encrid: null,
      kltg: {}
    }
  },
  methods: {
    open(kltg_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/kltg/getKltg.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getKltg"
          },
          getKltg: {
            kltg_encrid: kltg_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.kltg = res.data.getKltg;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmKltg() { 
      this.$axios
        .post("ares/json/ares/huov/kltg/rmKltg.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmKltg"
          },
          rmKltg: {
            kltg_encrid: this.kltg.kltg_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/huov/onHuov/' + res.data.rmKltg.huov_encrid); 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmKltg.text,
              color: res.data.rmKltg.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

